import {useEffect, useRef} from 'react';

const backHandlerStack: (() => boolean)[] = [];

export const useAndroidBackHandler = (
  handler: () => boolean,
  enabled = true
) => {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!enabled) return;

    const wrapper = () => handlerRef.current();
    backHandlerStack.push(wrapper);

    return () => {
      const index = backHandlerStack.indexOf(wrapper);
      if (index > -1) backHandlerStack.splice(index, 1);
    };
  }, [enabled]);
};

export const runAndroidBackHandlers = () => {
  return [...backHandlerStack].reverse().some((handler) => handler());
};
